var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAllokatorV2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.521484 5.36349C0.521484 2.8727 2.54067 0.853516 5.03146 0.853516H23.0713C25.5621 0.853516 27.5813 2.8727 27.5813 5.36349V23.4034C27.5813 25.8942 25.5621 27.9134 23.0714 27.9134H5.03146C2.54067 27.9134 0.521484 25.8942 0.521484 23.4034V5.36349Z",
    fill: "#03A771"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8945 14.4198L13.8945 18.7185L10.1367 16.7068V12.2811L13.8945 14.4198Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.240574,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1443 12.5619C18.1441 12.4024 18.102 12.2457 18.0222 12.1076C17.9423 11.9695 17.8276 11.8548 17.6894 11.775L14.5055 9.95562C14.3672 9.87577 14.2103 9.83374 14.0506 9.83374C13.891 9.83374 13.7341 9.87577 13.5958 9.95562L10.4119 11.775C10.2737 11.8548 10.159 11.9695 10.0791 12.1076C9.99931 12.2457 9.95719 12.4024 9.95703 12.5619V16.2007C9.95719 16.3602 9.99931 16.5169 10.0791 16.655C10.159 16.7931 10.2737 16.9078 10.4119 16.9875L13.5958 18.8069C13.7341 18.8868 13.891 18.9288 14.0506 18.9288C14.2103 18.9288 14.3672 18.8868 14.5055 18.8069L17.6894 16.9875C17.8276 16.9078 17.9423 16.7931 18.0222 16.655C18.102 16.5169 18.1441 16.3602 18.1443 16.2007V12.5619Z",
    stroke: "white",
    strokeWidth: 1.21563,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0742 12.1072L14.0314 14.3814L17.9885 12.1072",
    stroke: "white",
    strokeWidth: 1.21563,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0391 18.9271V14.3787",
    stroke: "white",
    strokeWidth: 0.481149,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.12785 6.73261C10.5086 5.89524 12.3133 5.24194 14.0461 5.24194C19.095 5.24194 23.1879 9.33488 23.1879 14.3838C23.1879 19.4327 19.095 23.5256 14.0461 23.5256C8.99723 23.5256 4.9043 19.4327 4.9043 14.3838C4.9043 12.7646 5.32526 11.2437 6.0637 9.92462",
    stroke: "white",
    strokeWidth: 1.21563,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3125 6.10132C8.44535 6.10132 9.36421 7.01926 9.36426 8.1521C9.36426 9.28498 8.44538 10.2039 7.3125 10.2039C6.17966 10.2038 5.26172 9.28495 5.26172 8.1521C5.26177 7.01929 6.17969 6.10136 7.3125 6.10132Z",
    fill: "white",
    stroke: "#03A771",
    strokeWidth: 1.21563
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.9709,
    cy: 20.5739,
    r: 1.8424,
    fill: "#03A771",
    stroke: "white",
    strokeWidth: 1.21563
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllokatorV2);
export default __webpack_public_path__ + "static/media/allokatorV2.070794ad50b7d56d49352b5e1963d746.svg";
export { ForwardRef as ReactComponent };